import { React, useState, useContext, useEffect, useCallback } from 'react'
import useApi from 'common/hooks/useApi'
import { LayoutContext } from 'common/ducks/index'
import { People, CheckBoxOutlineBlank } from '@mui/icons-material';
import styled from 'styled-components'
import useAppTitle from 'common/hooks/useAppTitle'
import { DatePicker } from '@mui/x-date-pickers'
import moment from 'moment'
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ModuleRegistry, AllCommunityModule, themeAlpine, provideGlobalGridOptions } from 'ag-grid-community'
import { Autocomplete, Grid, TextField, Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Typography,
Chip, CardContent, Card, DialogContentText, DialogContent, Dialog, OutlinedInput, ListItemText, Box, Checkbox, Switch } from '@mui/material'
import { UserContext } from 'account'
import { momentumLogo } from 'constants/assets'
import BtnCellRenderer from './BtnCellRenderer'
import ProgramChip from './ProgramChip'



ModuleRegistry.registerModules([ AllCommunityModule ]);
provideGlobalGridOptions({
    theme: "legacy",
});

function Trainers() {
  const queryParams = new URLSearchParams(window.location.search)
  const paymentStatus = queryParams.get("state")
  const user = useContext(UserContext)
  const [rowData, setRowData] = useState([])
  const defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true,
    wrapText: true,
    autoHeight: true,
  }
  const [colDefs,] = useState([
    {
      headerName: 'Name',
      field: 'reportLink',
      width: 150,
      cellRenderer: (params) => {
          return <a href={params.data?.reportLink}>{params.data?.name}</a>
      }
    },
    { field: "tags", cellRenderer: BtnCellRenderer, flex: 2, minWidth: 175 },
    { field: "momentumScore", width: 175, cellStyle: {textAlign: 'center'} },
    { field: "checkIn", cellDataType: 'dateString', width: 125 },
    { field: "programs", cellRenderer: ProgramChip, flex: 2, minWidth: 175, },
    { field: "programInfo", headerName: 'Recent Activity', flex: 2, minWidth: 175, },
    { field: "paymentStatus", width: 150 },
  ]);

  useAppTitle('Trainer Dashboard')

  const { setAppLoading } = useContext(LayoutContext)

  const [topCards, settopCards] = useState({awaiting: '', need: '', ready: '',  clientCount: '',})
  const [programList, setProgramList] = useState([])
  const [bulkProgram, setBulkProgram] = useState(null)
  const [date, setDate] = useState(moment())
  const [tagList, setTagList] = useState([])
  const [bulkListValue, setBulkListValue] = useState(null)
  const [bio, setBio] = useState()
  const [image, setImage] = useState()
  const [url, setUrl] = useState()
  const [userName,setUserName] = useState(user?.username)
  const [showPaymentModal, setShowPaymentModal] = useState(false)
  const [athleteList, setAthleteList] = useState([])
  const [personName, setPersonName] = useState([]);
  const [selectedObjects, setSelectedObjects] = useState([])
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState(false)

  const [{ loading: listLoading }, info ] = useApi({url: 'metrics/athlete_info/'}, {manual: true})

  const [, sendBulkAssign] = useApi(
    {
      method: 'POST',
      url: 'trainers/athlete_tags/bulk_assign/',
    },
    { manual: true }
  )

  const [, sendBulkRemove] = useApi(
    {
      method: 'POST',
      url: 'trainers/athlete_tags/bulk_remove/',
    },
    { manual: true }
  )

  const [{ loading: uploadLoading }, upload] = useApi(
    {
      method: 'POST',
      url: 'public_trainers/upload_pic/',
    },
    { manual: true }
  )

  const [, updateProfile] = useApi(
    {
      method: 'POST',
      url: 'public_trainers/update_profile/',
    },
    { manual: true }
  )

  const [, sendMessage] = useApi(
    {
      method: 'POST',
      url: 'messages/bulk_message/',
    },
    { manual: true }
  )

  const [{ data: subscriptionsData = {} }] =  useApi('subscriptions/')

  const fetchData = useCallback(
    async () => {
      const response = await info()
      setRowData(response?.data.clientInfo)
      settopCards(response?.data.clientPanel)
      setProgramList(response?.data.programs)
      setTagList(response?.data.tagList)
      setImage(response?.data?.image)
      setUrl(response?.data?.url)
      setAthleteList(response?.data.clientInfo?.map((row) => ({'id': row.id, 'name': row.name, 'email': row.email})))
    }, [ info]
  )

  useEffect(() => {
      fetchData()
  }, [fetchData, info])

  useEffect(() => {
      setAppLoading(listLoading || uploadLoading)
  }, [listLoading, uploadLoading, setAppLoading])

  const handleBulkProgramChange = (event: SelectChangeEvent) => {
    setBulkProgram(event.target.value);
  };

  async function bulkAssignProgram() {
    const body = {
        'id': bulkProgram?.id,
        'tags': bulkListValue,
        'start_date': date.format('YYYY-MM-DD'),
    }
    await sendBulkAssign({
        data: body,
    })
    fetchData()
  }

  async function bulkRemoveProgram() {
    const body = {
        'id': bulkProgram?.id,
        'tags': bulkListValue,
        'start_date': date,
    }
    await sendBulkRemove({
        data: body,
    })
    fetchData()
  }

  function onFileChange(event) {
    if(event.target.files[0].size > 25000000) {
       alert("File is too big! Max size is 25 MB");
    }
    const file = event.target.files[0]
    const formData = new FormData()
    formData.append('id', user?.id)
    formData.append('file', file)
    upload({
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    })
    fetchData()
  }

  const saveProfile = () => {
    const body = {
      'id': user?.id,
      'bio': bio,
      'username': userName,
    }
    updateProfile({
        data: body,
    }).then((response) => {
      if(response?.data?.warning){
          alert(response?.data?.warning)
      }
      fetchData()
    })
  }

  useEffect(() => {
    if (paymentStatus === 'succeeded') {
      if (subscriptionsData.subscriptions) {
        const subscription = subscriptionsData.subscriptions?.find((s) => s.status === 'active' || 'trialing')
        if (subscription) {
          setShowPaymentModal(true)
        }
      }
    }
  }, [subscriptionsData.subscriptions])

  const handleChange = (event) => {
    const selectedIds = event.target.value;
    const nextSelectedObjects = selectedIds.map((id) =>
      athleteList.find((item) => item.id === id)
    )
    setSelectedObjects(nextSelectedObjects);
  }

  async function bulkMessage() {
    const body = {
        'athletes': selectedObjects,
        'message': message,
        'type': messageType,
    }
    if (selectedObjects.length > 0 && message.length > 0){
      await sendMessage({
          data: body,
      }).then(response => {
        if (response.status === 201) {
          alert('Broadcast Sent')
        }
      })
    }
  }

  const handleTypeChange = (event) => {
    setMessageType(event.target.checked);
  }

  return (
    <Trainers.Stylesheet>
      <div style={{ paddingTop: 25, paddingBottom: 25, paddingRight: 100,
        position: 'absolute', right: 0}} >
          <Chip label={topCards?.clientCount} color='teal' size="Large" />
      </div>

      <div style={{ display: 'flex', flexDirections: 'row', justifyContent: 'center',
        gap: 64, paddingTop: 60, paddingBottom: 50}}>
        <Grid container spacing={4} style={{minWidth: 200, justifyContent: 'center'}}>
          <Grid size={3} style={{minWidth: 275}}>
            <Card className="ready__card" style={{minWidth: 275, boxShadow: 'none', marginBottom: 30}}>
              <CardContent style={{ backgroundColor: '#C7E8ED', textAlign: 'center', width: '275px', minWidth: 275}}>
                  <People />
                  <Typography>{topCards?.ready}</Typography>
                  <Typography>Athletes Ready!</Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid size={3} style={{minWidth: 275}}>
          <Card className="in-need__card" style={{minWidth: 275, boxShadow: 'none', marginBottom: 30}}>
            <CardContent style={{ backgroundColor: '#FFF5E5', textAlign: 'center', width: '275px', minWidth: 275}}>
              <People />
              <Typography>{topCards?.awaiting}</Typography>
              <Typography>Athletes Awaiting Check-In!</Typography>
            </CardContent>
          </Card>
          </Grid>
          <Grid size={3} style={{minWidth: 275}}>
          <Card className="alert__card" style={{minWidth: 275, boxShadow: 'none', marginBottom: 30}}>
            <CardContent style={{ backgroundColor: '#FF7262', textAlign: 'center', width: '275px', minWidth: 275}}>
              <People />
              <Typography>{topCards?.need}</Typography>
              <Typography>Athletes In Need!</Typography>
            </CardContent>
          </Card>
          </Grid>
        </Grid>
      </div>
      <div
        className="ag-theme-alpine"
        style={{ height: 550, margin: '0% 7.5%' }} // the Data Grid will fill the size of the parent container
      >
        <AgGridReact
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          suppressMenuHide
        />
      </div>

      {user?.isPublicTrainer && (
        <Card style={{margin: '5% 7.5%', overflow: 'scroll'}}>
          <h2 style={{
            paddingLeft: 30,
            paddingTop: 10,
            paddingBottom: 10,
            backgroundColor: 'teal',
            color: 'white'
          }}> Edit Public Profile </h2>
          <Grid container style={{display: 'flex'}}>
            <Grid size={4} style={{minWidth: 250}}>
            <div style={{display: 'inline-grid', margin: '15px 100px'}}>
              Image Preview
              <img src={image || momentumLogo} alt="" style={{height: 300, width: 300}}/>
              <label htmlFor="pic-upload" style={{ width: '50%', paddingLeft: 200 }}>
                <input
                  accept=".jpg,.png"
                  type="file"
                  id="pic-upload"
                  style={{ display: 'none' }}
                  onChange={onFileChange}
                />
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  style={{ marginTop: '5%' }}
                >
                  Upload
                </Button>
              </label>
            </div>
            </Grid>
            <Grid size={4} style={{marginTop: 20, minWidth: 350}}>
              <TextField
                defaultValue={user?.biography}
                value={bio}
                variant='outlined'
                label='Biography'
                rows={15}
                multiline
                style={{width: '350px', margin: '15px 50px'}}
                onChange={(e)=>{setBio(e.target.value)}}
                />
            </Grid>
            <Grid size={4} style={{marginTop: 20, minWidth: 450}}>
              <div>
                <TextField
                  variant='outlined'
                  label='User Name'
                  defaultValue={user?.username}
                  value={userName}
                  style={{margin: '15px 50px'}}
                  onChange={(e)=>{setUserName(e.target.value)}}
                  />
                <Button
                  variant="contained"
                  color="primary"
                  style={{height: '55px', width: '100px', marginRight: '20px', marginTop: '15px'}}
                  onClick={saveProfile}
                  >
                  Save
                </Button>
                <div style={{width: 200, marginLeft: 50, marginTop: 20}}>
                  Link:
                </div>
                <div style={{width: 400 , marginLeft: 50}}>
                  {url}
                </div>
              </div>
            </Grid>
          </Grid>
        </Card>
      )}

      <Card style={{margin: '5% 7.5%', overflow: 'scroll'}}>
        <h2 style={{
          paddingLeft: 30,
          paddingTop: 10,
          paddingBottom: 10,
          backgroundColor: 'teal',
          color: 'white'
        }}> Bulk Program Assign </h2>

        <div style={{padding: '40px', paddingLeft: 100, display: 'flex', justifyContent: 'flex-start'}}>
          <Autocomplete
            disablePortal
            value={bulkListValue}
            options={tagList}
            style={{ marginRight: 80, width: 300 }}
            renderInput={(params) => <TextField {...params}  label="Tags" variant='outlined'/>}
            onChange={(event, newValue) => {setBulkListValue(newValue)}}
          />
            <FormControl variant='outlined' style={{marginRight: 80, minWidth: '40px', width: 300}} >
            <InputLabel >Program</InputLabel>
              <Select
                value={bulkProgram}
                onChange={handleBulkProgramChange}
              >
                {programList?.map((row) => (
                            <MenuItem key={row.name} value={row}>{row?.name}</MenuItem>
                        ))}
              </Select>
            </FormControl>
            <DatePicker
              style={{ paddingRight: '3%', width: 300}}
              format="YYYY-MM-DD"
              inputVariant="outlined"
              label="Start Date"
              value={date}
              onChange={(value) => setDate(value)}
            />
              {bulkListValue && bulkProgram && (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{height: '55px', width: '100px', marginRight: '20px'}}
                    onClick={bulkAssignProgram}
                    >
                    Assign
                  </Button>
                  <Button
                    variant="contained"
                    style={{height: '55px', width: '100px', backgroundColor: '#FF7262', color: 'white'}}
                    onClick={bulkRemoveProgram}
                    >
                    Remove
                  </Button>
                </>
              )}
        </div>
      </Card>

      <Card style={{margin: '5% 7.5%', overflow: 'scroll'}}>
        <h2 style={{
          paddingLeft: 30,
          paddingTop: 10,
          paddingBottom: 10,
          backgroundColor: 'teal',
          color: 'white'
        }}> Broadcast </h2>

        <div style={{padding: '40px', paddingLeft: 100, display: 'flex', justifyContent: 'flex-start'}}>
          <Box sx={{ p: 2, width: 500}}>
            <FormControl fullWidth>
              <InputLabel id="mui-multiple-checkbox-label">Athletes</InputLabel>
              <Select
                labelId="mui-multiple-checkbox-label"
                id="mui-multiple-checkbox"
                multiple
                value={selectedObjects.map((obj) => obj.id)}
                onChange={handleChange}
                input={<OutlinedInput label="Athletes" />}
                renderValue={(selectedIds) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selectedIds.map((id) => {
                      const matchedItem = athleteList?.find((item) => item.id === id);
                      return <Chip key={id} label={matchedItem ? matchedItem.name : id} />;
                    })}
                  </Box>
                )}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 250,
                      width: 250,
                    },
                  },
                }}
              >
                {athleteList?.map((item) => {
                  const isChecked = selectedObjects.some((obj) => obj.id === item.id);

                  return (
                    <MenuItem key={item.id} value={item.id}>
                      <Checkbox checked={isChecked} />
                      <ListItemText primary={item.name} />
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>

          <TextField
            value={message}
            variant='outlined'
            label='Message'
            rows={5}
            multiline
            style={{width: '500px', margin: '15px 80px'}}
            onChange={(e)=>{setMessage(e.target.value)}}
           />
          <div style={{marginTop: 10, display: 'flex'}}>
            <Typography style={{marginTop: 7}}>
              Messages
            </Typography>
            <Switch
              checked={messageType}
              onChange={handleTypeChange}
            />
            <Typography style={{marginTop: 7}}>
              Athlete Report
            </Typography>

            {selectedObjects && message && (
              <Button
                variant="contained"
                color="primary"
                style={{height: 55, width: 100, marginRight: 80, marginLeft: 80}}
                onClick={bulkMessage}
                >
                Send
              </Button>
            )}
          </div>
        </div>
      </Card>

      <Dialog open={showPaymentModal} onClose={() => setShowPaymentModal(false)} >
      <DialogContent style={{height: '50rem', width: '40rem'}}>
        <DialogContentText>
        <>
          <strong style={{ fontWeight: 'bolder' }}>
            Welcome to Sidekick!
          </strong>
          <br />
          <br />
          <strong style={{ fontWeight: 'bolder' }}>
            Subscription added!
          </strong>
          <br />
          <br />
          <div>
            Trainer Features have been added to your account
          </div>
          <br />
          <strong style={{ fontWeight: 'bolder' }}>
            You now have access to the platform
          </strong>

          <br />
          <br />
          Watch this to help get started
          <br />
          <br />
          <iframe title='Welcome Video' style={{height: '30rem', width: '35rem'}} loading="lazy"src="https://app.storylane.io/demo/vsovgx2wz2aj?embed=popup" name="sl-embed" allow="fullscreen" allowFullscreen/>
          </>
        </DialogContentText>
      </DialogContent>
    </Dialog>

    </Trainers.Stylesheet>
  )
}

Trainers.Stylesheet = styled.div`

  .ag-theme-alpine {
    --ag-header-background-color: teal;
    --ag-header-font-color: white;
  }
  .ag-theme-alpine .ag-header-cell {
    color: white;
  }
  .ag-body-viewport {
    height: auto !important;
  }

  .ag-theme-alpine .ag-icon .ag-icon-filter {
    color: white;
  }

  .ag-theme-alpine .ag-header-icon {
    color: white;
  }

  .ag-theme-alpine .ag-icon {
    color: white;
  }
`

export default Trainers
